(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-liver-support-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dd-liver-quiz')) {
    customElements.define('dd-liver-quiz', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') {
          this.observeViewport();
          return;
        }
        this.dataset.ready = 'true';
        this.intro = this.querySelector('[data-dd-intro]');
        this.flow = this.querySelector('[data-dd-flow]');
        this.screens = Array.from(this.querySelectorAll('[data-dd-screen]'));
        this.results = Array.from(this.querySelectorAll('[data-dd-result]'));
        this.result = null;
        this.back = this.querySelector('[data-dd-back]');
        this.index = 0;
        this.answers = {};
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
        this.scheduleFit = () => {
          cancelAnimationFrame(this.fitFrame);
          this.fitFrame = requestAnimationFrame(() => this.fitViewport());
        };
        this.fitObserver = new MutationObserver(this.scheduleFit);
        this.observeViewport();
        document.fonts.ready.then(this.scheduleFit);
      }

      observeViewport() {
        this.fitObserver.observe(this, { subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['hidden'] });
        this.addEventListener('load', this.scheduleFit, true);
        window.addEventListener('resize', this.scheduleFit);
        this.scheduleFit();
      }

      disconnectedCallback() {
        this.fitObserver?.disconnect();
        window.removeEventListener('resize', this.scheduleFit);
        this.removeEventListener('load', this.scheduleFit, true);
        cancelAnimationFrame(this.fitFrame);
        clearTimeout(this.autoAdvanceTimer);
        clearTimeout(this.resultTimer);
        clearInterval(this.analysisTimer);
      }

      fitViewport() {
        if (!this.isConnected) return;
        delete this.dataset.fit;
        if (this.classList.contains('dd-quiz--result')) return;
        const activeKind = this.screens[this.index]?.dataset.ddKind;
        if (activeKind === 'informative' || activeKind === 'story') return;
        // Reduce spacing and media before typography; never clip content or disable scrolling.
        for (let level = 1; level <= 3 && this.getBoundingClientRect().height > window.innerHeight + 1; level++) {
          this.dataset.fit = String(level);
        }
      }

      onClick(event) {
        const truemed = event.target.closest('[data-open-truemed]');
        if (truemed) {
          const opener = document.querySelector('.truemed-instructions-open');
          if (opener) {
            event.preventDefault();
            opener.click();
          }
          return;
        }
        const start = event.target.closest('.js-dd-start');
        const next = event.target.closest('.js-dd-next');
        const back = event.target.closest('[data-dd-back]');
        const close = event.target.closest('[data-dd-close]');
        const restart = event.target.closest('[data-dd-restart]');
        const atc = event.target.closest('.js-dd-atc');
        const alternative = event.target.closest('[data-dd-alternative]');
        if (alternative) { const target = this.results.find(item => item.dataset.ddPresentation === alternative.dataset.ddAlternative); if (target) this.showResult(target); }
        if (start || next || atc) event.preventDefault();
        if (start) this.start();
        if (next) this.next(next.closest('[data-dd-screen]'));
        if (back) this.previous();
        if (close || restart) this.reset();
        if (atc) this.addToCart(atc);
      }

      onChange(event) {
        if (!event.target.matches('input[type="radio"], input[role="switch"]')) return;
        const screen = event.target.closest('[data-dd-screen]');
        const values = event.target.matches('[role="switch"]')
          ? Array.from(screen.querySelectorAll('input[role="switch"]')).map(input => input.checked ? 'Yes' : 'No')
          : Array.from(screen.querySelectorAll('input[type="radio"]:checked')).map(input => input.value);
        this.answers[screen.dataset.ddNumber] = values;
        const error = screen.querySelector('[data-dd-error]');
        if (error) error.hidden = true;
        if (screen.dataset.ddKind === 'question') {
          clearTimeout(this.autoAdvanceTimer);
          this.autoAdvanceTimer = setTimeout(() => {
            if (!screen.hidden && event.target.checked) this.next(screen);
          }, 250);
        }
      }

      start() {
        this.classList.remove('dd-quiz--intro');
        this.intro.hidden = true;
        this.flow.hidden = false;
        this.show(0);
      }

      matchesRule(screen) {
        const rule = (screen.dataset.ddRule || '').trim();
        if (!rule) return true;
        const match = /^Q([1-9]\d*)A([1-4])$/i.exec(rule);
        if (!match) return false;
        const question = this.screens.find(item => item.dataset.ddKind === 'question' && item.dataset.ddNumber === match[1]);
        return question?.querySelector('[data-dd-answer]:checked')?.dataset.ddAnswer === match[2];
      }

      show(index, direction = 1) {
        this.classList.remove('dd-quiz--result');
        clearTimeout(this.autoAdvanceTimer);
        clearInterval(this.analysisTimer);
        clearTimeout(this.resultTimer);
        this.results.forEach(screen => { screen.hidden = true; });
        this.result = null;
        this.screens.forEach(screen => { screen.hidden = true; });
        while (index >= 0 && index < this.screens.length && !this.matchesRule(this.screens[index])) index += direction;
        this.index = index;
        const active = this.screens[index];
        this.classList.toggle('dd-quiz--insight', active?.dataset.ddKind === 'informative');
        if (index < 0) return this.reset();
        if (!active) return this.showResult();
        active.hidden = false;
        const profile = active.querySelector('[data-dd-profile-copy]');
        if (profile) { profile.dataset.template ||= profile.innerHTML; const ageText = document.createElement('span'); ageText.textContent = this.answers['1']?.[0] || 'age bracket'; profile.innerHTML = profile.dataset.template.replace('{your age bracket}', () => ageText.innerHTML); }
        window.scrollTo({top:0, behavior:'instant'});
        this.back.hidden = !this.screens.slice(0, index).some(screen => this.matchesRule(screen));
        active.querySelector('h2[tabindex], input, .js-dd-next, button:not([data-dd-close])')?.focus({ preventScroll: true });
        if (active.dataset.ddKind === 'analyzing') this.analyze(active);
      }

      next(screen) {
        if (!screen || screen.hidden) return;
        const required = screen.querySelector('[data-dd-required]');
        if (required) {
          const groups = Array.from(required.querySelectorAll('fieldset'));
          const valid = groups.length
            ? groups.every(group => group.querySelector('input:checked'))
            : !!required.querySelector('input:checked');
          if (!valid) {
            const error = screen.querySelector('[data-dd-error]');
            if (error) { error.hidden = false; error.focus?.(); }
            return;
          }
        }
        this.show(this.index + 1);
      }

      previous() {
        let index = this.index - 1;
        while (index >= 0 && this.screens[index].dataset.ddKind === 'analyzing') index -= 1;
        this.show(index, -1);
      }

      analyze(screen) {
        clearInterval(this.analysisTimer);
        const output = screen.querySelector('[data-dd-analysis-progress]');
        let progress = 0;
        this.analysisTimer = setInterval(() => {
          progress = Math.min(100, progress + 4);
          if (output) output.textContent = progress + '%';
          screen.style.setProperty('--analysis', progress + '%');
          if (progress === 100) {
            clearInterval(this.analysisTimer);
            this.resultTimer = setTimeout(() => this.show(this.index + 1), 250);
          }
        }, 100);
      }

      resultPresentation() {
        // Answer slots, rather than editable display text, define the routing inputs.
        const answer = number => Number(this.screens.find(screen => screen.dataset.ddKind === 'question' && screen.dataset.ddNumber === String(number))?.querySelector('[data-dd-answer]:checked')?.dataset.ddAnswer);
        const shortQuiz = this.dataset.shortQuiz === 'true';
        const symptoms = shortQuiz ? answer(3) : 0;
        const concern = answer(2); // alcohol, digestion/bloating, energy/sluggishness, prevention
        // Short Q3 combines severity and timeline: most days (1/2), some days (3), now and then (4).
        const severity = shortQuiz ? ({ 1: 1, 2: 1, 3: 2, 4: 3 }[symptoms] || 0) : answer(4);
        // A year or more (1), recent (2), months (3), no established duration (4).
        const timeline = shortQuiz ? ({ 1: 1, 2: 4, 3: 3, 4: 4 }[symptoms] || 0) : answer(5);
        const wanted = answer(shortQuiz ? 5 : 6); // recovery, digestion, energy, prevention
        const frequency = answer(shortQuiz ? 4 : 8); // several times/week, once/twice/week, monthly, rarely
        const weekly = frequency === 1 || frequency === 2;
        const low = severity === 3;
        const duration = () => {
          if (severity === 1 || severity === 2) return 'three';
          if ([1, 2, 3].includes(timeline)) return 'three';
          return 'one';
        };
        if (concern === 1 && weekly) return 'drink';
        if (concern === 4 && low) return 'daily';
        if (concern === 2 || concern === 3) return duration();
        // Tie-break with the wanted result, retaining each bundle's eligibility gate.
        if (wanted === 1 && weekly) return 'drink';
        if (wanted === 4 && low) return 'daily';
        return duration();
      }

      selectResult(selectedResult) {
        if (selectedResult && this.results.includes(selectedResult)) return selectedResult;
        const presentation = this.resultPresentation();
        return this.results.find(screen => screen.dataset.ddPresentation === presentation)
          || this.results.find(screen => screen.dataset.ddPresentation === 'one')
          || this.results[0];
      }

      showResult(selectedResult) {
        this.classList.add('dd-quiz--result');
        this.index = this.screens.length;
        this.classList.remove('dd-quiz--insight');
        this.results.forEach(screen => { screen.hidden = true; });
        this.result = this.selectResult(selectedResult);
        this.screens.forEach(screen => { screen.hidden = true; });
        this.back.hidden = false;
        this.result.hidden = false;
        const alternative = this.result.querySelector('[data-dd-alternative]');
        if (alternative) alternative.parentElement.hidden = !this.results.some(item => item.dataset.ddPresentation === alternative.dataset.ddAlternative);
        const first = this.answers['1']?.[0];
        const concern = this.answers['2']?.[0];
        const age = this.result.querySelector('[data-dd-summary-age]');
        const concernNode = this.result.querySelector('[data-dd-summary-concern]');
        if (age && first) age.textContent = first;
        if (concernNode && concern) { const slot = this.screens.find(s => s.dataset.ddNumber === '2')?.querySelector('input:checked')?.dataset.ddAnswer; concernNode.textContent = ['Alcohol recovery','Digestion and bloating','Energy and vitality','Proactive care'][Number(slot)-1] || concern; }
        this.result.querySelector('h2')?.focus?.({ preventScroll: true });
        window.scrollTo({top:0, behavior:'instant'});
      }

      reset() {
        clearTimeout(this.resultTimer);
        this.results.forEach(screen => { screen.hidden = true; });
        this.result = null;
        this.classList.remove('dd-quiz--insight');
        clearInterval(this.analysisTimer);
        clearTimeout(this.autoAdvanceTimer);
        this.querySelectorAll('input[type="radio"], input[role="switch"]').forEach(input => { input.checked = false; });
        this.answers = {};
        this.flow.hidden = true;
        this.classList.remove('dd-quiz--result');
        this.classList.add('dd-quiz--intro');
        this.intro.hidden = false;
        this.index = 0;
        this.querySelector('.js-dd-start')?.focus({ preventScroll: true });
      }

      addToCart(button) {
        const result = button.closest('[data-dd-result]');
        const id = Number(result?.dataset.variantId);
        if (!id || button.getAttribute('aria-disabled') === 'true') return;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('is-loading');
        return Promise.resolve().then(() => {
          const item = { id, quantity:1 };
          const sellingPlan = result?.dataset.sellingPlan?.trim();
          if (sellingPlan) {
            const planId = Number(sellingPlan);
            if (!/^\d+$/.test(sellingPlan) || !Number.isSafeInteger(planId) || planId <= 0) throw new Error('Invalid selling plan ID');
            item.selling_plan = planId;
          }
          const payload = { items:[item] };
          return typeof window.addProduct === 'function'
            ? window.addProduct(payload)
            : fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body:JSON.stringify(payload) }).then(response => { if (!response.ok) throw new Error('Cart add failed'); return response.json(); });
        }).then(() => {
          if (typeof window.openCart === 'function') return window.openCart();
          window.location.href = '/cart';
        }).catch(() => {
          const label = button.querySelector('.n-btn__label');
          if (label) label.textContent = 'Try again';
        }).finally(() => {
          button.setAttribute('aria-disabled', 'false');
          button.classList.remove('is-loading');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
